import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';
import globals from "../../globals";

export default {

    initialise(Hero) {
        this.Node = findDOMNode(Hero);
        this.h1 = this.Node.querySelectorAll('.heading h1')[0];
        this.h4 = this.Node.querySelectorAll('.heading h4')[0];
        this.leadCopy = [...this.Node.querySelectorAll('.hero p')];

        let tl = new TimelineLite();
        tl.delay(0.25);

        if (this.h1) {
            tl.fromTo(this.h1, 0.5, {y: -50, opacity: 0}, {y: 0, opacity: 1, ease: Power4.easeOut});
        }

        if (this.leadCopy.length > 0) {
            tl.staggerFromTo(this.leadCopy, 0.3, {x: -50, opacity: 0}, {x: 0, opacity: 1}, 0.2, 0);
        }

        if (this.h4) {
            tl.fromTo(this.h4, 1, globals.getSubAnimation(this.h4), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)}, 0.25);
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Hero/animations.js